const apiEnvMapping = {
  localhost: '-staging',
  'dev-invoice.airwallex.com': '-dev',
  'staging-invoice.airwallex.com': '-staging',
  'demo-invoice.airwallex.com': '-demo',
  'invoice.sandbox.airwallex.com': '.sandbox',
  'invoice.airwallex.com': '',
};

const pageEnvMapping = {
  localhost: 'staging',
  'dev-invoice.airwallex.com': 'dev',
  'staging-invoice.airwallex.com': 'staging',
  'demo-invoice.airwallex.com': 'demo',
  'invoice.sandbox.airwallex.com': 'sandbox',
  'invoice.airwallex.com': 'prod',
};

export const getApiEnvByHost = (): string => {
  const hostname = window.location.hostname as keyof typeof apiEnvMapping;
  return apiEnvMapping[hostname] || '';
};

export const getPageEnvByHost = (): string => {
  const hostname = window.location.hostname as keyof typeof pageEnvMapping;
  return pageEnvMapping[hostname] || 'prod';
};

export const getAirwayUrl = (): string => {
  const hostname = window.location.hostname;
  return `https://${hostname === 'localhost' ? 'staging-invoice.airwallex.com' : hostname}/billing/payer-web-api`;
};

export const getCorpsiteUrl = (): string => {
  const airwallexEnv = getPageEnvByHost();
  if (['staging', 'demo', 'dev'].includes(airwallexEnv)) {
    return `https://${airwallexEnv}.airwallex.com`;
  }
  if (airwallexEnv === 'sandbox') {
    return 'https://www.sandbox.airwallex.com';
  }
  if (airwallexEnv === 'prod') {
    return 'https://www.airwallex.com';
  }
  return 'https://staging.airwallex.com';
};
